import React from 'react'
import Layouts from '../../Layouts/Layouts'
import { StyledMainPageRightSection } from '../dashboard/style.dashboard'

const Enquiries = () => {
  return (
    <>
     <Layouts>

        <StyledMainPageRightSection>
          <h1>ON Customer Enquiries</h1>
        </StyledMainPageRightSection>
     </Layouts>
     

    </>
  )
}

export default Enquiries
